import { REPORT_ANALYSIS_MAX_BARS } from "./candleTimeframeBarBudget";

export const REPORT_MAX_CANDLES_LABEL = REPORT_ANALYSIS_MAX_BARS.toLocaleString();

/** Static help under the Timeframe field on the generate wizard. */
export const REPORT_TIMEFRAME_FIELD_HELP =
  "Choose the candle size used for market context on this report.";

export function reportCandleBudgetBlockedMessage(timeframe: string): string {
  const tf = timeframe.trim() || "This timeframe";
  return `${tf} can't be used for this date range — it needs more candles than we collect (limit ${REPORT_MAX_CANDLES_LABEL}). Choose a larger candle timeframe to continue.`;
}

export function reportTimeframeFitsMessage(
  timeframe: string,
  windowLabel?: string,
  candleCount?: number
): string {
  const countPart =
    typeof candleCount === "number" && Number.isFinite(candleCount)
      ? `About ${Math.round(candleCount).toLocaleString()} candles`
      : "Within the candle limit";
  const scope = windowLabel ? ` for ${windowLabel}` : "";
  return `${countPart} at ${timeframe}${scope}.`;
}

export function reportTimeframeAdjustedMessage(
  chosen: string,
  used: string,
  windowLabel?: string,
  candleCount?: number
): string {
  const scope = windowLabel ? ` For ${windowLabel},` : "";
  const countPart =
    typeof candleCount === "number" && Number.isFinite(candleCount)
      ? ` (~${Math.round(candleCount).toLocaleString()} candles)`
      : "";
  return `You chose ${chosen}.${scope} this report will use ${used} candles${countPart} to stay within the ${REPORT_MAX_CANDLES_LABEL} candle limit.`;
}

export function reportTimeframeLikelyAdjustedMessage(
  chosen: string,
  suggested: string,
  windowLabel: string
): string {
  return `You chose ${chosen}. For ${windowLabel}, try ${suggested} or a shorter date range to stay within the ${REPORT_MAX_CANDLES_LABEL} candle limit.`;
}

export function reportTimeframeTooManyCandlesMessage(
  chosen: string,
  windowLabel: string,
  suggested: string | null,
  estimatedCount?: number
): string {
  const countPart =
    typeof estimatedCount === "number" && Number.isFinite(estimatedCount)
      ? ` (about ${Math.round(estimatedCount).toLocaleString()} candles at ${chosen})`
      : "";
  const fix = suggested
    ? ` Try ${suggested} or a shorter date range.`
    : " Try a larger timeframe or a shorter date range.";
  return `For ${windowLabel}, ${chosen} would exceed ${REPORT_MAX_CANDLES_LABEL} candles${countPart}.${fix}`;
}
